import { Collection, Length, ModelBase, ObservableCollection, Property } from '@skylab-shared/core';
import { CalculationMethod, ExchangeRateModel, VatTableItemModel } from '@skylab-shared/dataModel';
import { OrderSourceKind } from './common/order-source.kind';
import { OrderDeliveryModel } from './order-delivery.model';
import { OrderDocumentModel } from './order-document.model';
import { OrderItemModel } from './order-item.model';
import { OrderPaymentSummary } from './order-payment-summary.model';
import { OrderPaymentModel } from './order-payment.model';
import { OrderRecipientModel } from './order-recipient.model';
import { OrderSaleDocumentModel } from './order-sale-document.model';

export class OrderModel extends ModelBase {
    @Property({ identifiable: true })
    public id: string;

    @Property()
    public orderDate: Date;

    @Property()
    public statusId: number;

    @Property()
    public createdDate: Date;

    @Property(Date, {nullable: true})
    public dueDate: Date | null;

    @Property()
    public grossValue: number;

    @Property()
    public netValue: number;

    @Property({nullable: true})
    public comission: number;

    @Property({nullable: true})
    public externalNumber: string;

    @Property({nullable: true})
    public number: string;

    @Property({nullable: true})
    public orderCustomerLogin: string;

    @Property({nullable: true})
    @Length({ max: 1000 }, 'data-model.orders.validation.notes-private.length')
    public notesPrivate: string;

    @Property()
    public source: OrderSourceKind;

    @Property()
    public sourceProviderId: string;

    @Property({nullable: true})
    public notesPublic: string;

    @Property(OrderDeliveryModel, { nullable: true })
    public delivery: OrderDeliveryModel | null;

    @Property(OrderDocumentModel, { nullable: true })
    public document: OrderDocumentModel | null;

    @Property(OrderSaleDocumentModel, { nullable: true })
    public saleDocument: OrderSaleDocumentModel | null;

    @Property(OrderRecipientModel, { nullable: true })
    public recipient: OrderRecipientModel | null;

    @Collection({ type: OrderItemModel })
    public items: ObservableCollection<OrderItemModel>;

    @Collection({ type: OrderPaymentModel })
    public payments: ObservableCollection<OrderPaymentModel>;

    @Property()
    public paymentSummary: OrderPaymentSummary;

    @Property()
	public currencyId: string;

    //#region CALCULATIONS PURPOSE ONLY
	@Property()
    public calculationMethod: CalculationMethod;

    @Property()
    public exchangeRate: ExchangeRateModel;

    @Collection({ type: VatTableItemModel })
    public vatTableItems: ObservableCollection<VatTableItemModel>;
    //#endregion CALCULATIONS PURPOSE ONLY

    public override get isPersistent(): boolean {
        return this.id != null;
    }
}
